export interface BedbankPackageCapacity {
  guests?: number
  bedrooms?: number
  bathrooms?: number
}

export function getBedbankPackageMaxGuests(bedbankPackage?: App.BedbankPackage): number | undefined {
  const combinations = bedbankPackage?.capacities?.combinations
  if (!combinations?.length) return undefined

  return Math.max(...combinations.map(combination => combination.adults + combination.children + combination.teenagers))
}

export function getBedbankPackageCapacity(bedbankPackage?: App.BedbankPackage): BedbankPackageCapacity | undefined {
  const guests = getBedbankPackageMaxGuests(bedbankPackage)
  const bedrooms = bedbankPackage?.numberOfBedrooms
  const bathrooms = bedbankPackage?.numberOfBathrooms

  if (!guests && !bedrooms && !bathrooms) return undefined

  return { guests, bedrooms, bathrooms }
}
